import React from 'react';
import { formatDisplayDateTime } from '@/config';
import { Modal, Table, message } from 'antd';
import { useTranslation } from 'react-i18next';
import { WithoutPhoneCountModel } from '@/__generated';
import { apiSdk } from '@/httpClient';

type Props = {
  onClose: () => void;
};

/** Compteur « Sans téléphone » par caissier : billets vendus sans numéro sur les 30 derniers jours. */
export default function WithoutPhoneCountsModal({ onClose }: Props) {
  const { t } = useTranslation();
  const [rows, setRows] = React.useState<WithoutPhoneCountModel[]>([]);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    apiSdk.BookingPassengerService.withoutPhoneCounts({})
      .then(setRows)
      .catch(message.error)
      .finally(() => setLoading(false));
  }, []);

  return (
    <Modal open={true} width={700} title={t('withoutPhone_Title')} footer={null} onCancel={onClose}>
      <p>{t('withoutPhone_Description')}</p>
      <Table<WithoutPhoneCountModel>
        data-testid="without-phone-counts"
        rowKey="userId"
        loading={loading}
        dataSource={rows}
        pagination={false}
        size="small"
        locale={{ emptyText: t('withoutPhone_Empty') }}
        columns={[
          { title: t('withoutPhone_Cashier'), dataIndex: 'cashierName' },
          { title: t('withoutPhone_Tickets'), dataIndex: 'tickets', align: 'right' },
          { title: t('withoutPhone_LastSale'), dataIndex: 'lastSale', render: v => formatDisplayDateTime(v) },
        ]}
      />
    </Modal>
  );
}
